const getFrontLinks = () => document.getElementsByClassName('front-links')[0];

export const hideFooterFrontLinks = () => {
  const element = getFrontLinks();

  if (element) {
    element.style.display = 'none';
  }
};

export const showFooterFrontLinks = () => {
  const element = getFrontLinks();

  if (element) {
    element.style.display = 'block';
  }
};
